<script type="text/javascript">
export default {};
</script>

<template>
  <div class="socials-loader">
    <div class="socials-loader__item"></div>
    <div class="socials-loader__item"></div>
    <div class="socials-loader__item"></div>
  </div>
</template>

<style lang="scss">
@import '~styles/settings';

.socials-loader {
  display: flex;
  gap: 8px;
  margin: 12px 0 24px;

  &__item {
    border-radius: 4px;

    @include text-line(33.33%, 50px);
  }
}
</style>
